// extracted by mini-css-extract-plugin
export default {"addCommentContainer":"CommentBar_addCommentContainer__wQe8P","input":"CommentBar_input__zHpb2","button":"CommentBar_button__BKwZG"};